define('AA.OutOfStock', [
    'AA.OutOfStock.StockCheck.Model',
    'jQuery',
    'underscore'
], function(StockCheckModel, jQuery, _) {
    'use strict';

    var OOSUtils = {

        showOverlay: function showOverlay(message, subtext) {
            var text = message || 'Please wait while we verify item availability...';

            if (jQuery('.oos-overlay').length) {
                jQuery('.oos-overlay .oos-overlay-content p.oos-overlay-message').text(text);
                if (subtext) {
                    if (!jQuery('.oos-overlay .oos-overlay-subtext').length) {
                        jQuery('.oos-overlay .oos-overlay-content').append('<p class="oos-overlay-subtext">' + subtext + '</p>');
                    } else {
                        jQuery('.oos-overlay .oos-overlay-subtext').text(subtext);
                    }
                } else {
                    jQuery('.oos-overlay .oos-overlay-subtext').remove();
                }
                jQuery('.oos-overlay').show();
                return;
            }

            var overlayHtml = '<div class="oos-overlay">' +
                '<div class="oos-overlay-content">' +
                '<div class="oos-overlay-spinner"></div>' +
                '<p class="oos-overlay-message">' + text + '</p>' +
                (subtext ? '<p class="oos-overlay-subtext">' + subtext + '</p>' : '') +
                '</div>' +
                '</div>';

            jQuery('body').append(overlayHtml);
        },

        hideOverlay: function hideOverlay() {
            jQuery('.oos-overlay').remove();
        },

        checkAvailability: function checkAvailability(cartModel, callback) {
            var lines = cartModel.get('lines');
            var lineModels = lines && lines.models ? lines.models : [];

            if (!lineModels.length) {
                callback([], lineModels);
                return;
            }

            var itemIdMap = {};
            var lineMap = {};

            _.each(lineModels, function(line) {
                var item = line.get('item');
                var itemId = item.get('internalid').toString();
                var lineId = line.get('internalid');

                itemIdMap[itemId] = true;

                if (!lineMap[itemId]) {
                    lineMap[itemId] = [];
                }
                lineMap[itemId].push({
                    lineId: lineId,
                    lineModel: line,
                    itemName: item.get('displayname') || item.get('itemid') || ''
                });
            });

            var itemIds = Object.keys(itemIdMap);

            if (!itemIds.length) {
                callback([], lineModels);
                return;
            }

            OOSUtils.showOverlay();

            StockCheckModel.checkStock(itemIds)
                .done(function(response) {
                    OOSUtils.hideOverlay();

                    var oosItems = {};
                    var items = response && response.items ? response.items : [];

                    _.each(items, function(item) {
                        if (item.isOutOfStock) {
                            oosItems[item.internalid.toString()] = true;
                        }
                    });

                    var oosLines = [];
                    _.each(Object.keys(oosItems), function(itemId) {
                        var linesForItem = lineMap[itemId] || [];
                        _.each(linesForItem, function(lineInfo) {
                            oosLines.push(lineInfo);
                        });
                    });

                    callback(oosLines, lineModels);
                })
                .fail(function() {
                    OOSUtils.hideOverlay();
                    callback([], lineModels);
                });
        },

        removeOOSLines: function removeOOSLines(cart, oosLines, callback, subtext) {
            if (!oosLines.length) {
                if (callback) callback();
                return;
            }

            OOSUtils.showOverlay('Removing out of stock items...', subtext);

            var queue = [];

            _.each(oosLines, function(lineInfo) {
                queue.push(function() {
                    return cart.removeLine({ line_id: lineInfo.lineId });
                });
            });

            var chain = jQuery.Deferred().resolve();
            queue.forEach(function(fn) {
                chain = chain.then(fn);
            });
            chain.always(function() {
                OOSUtils.hideOverlay();
                if (callback) callback();
            });
        },

        renderBanner: function renderBanner(container, message, showRemoveLink) {
            var bannerHtml = '<div class="oos-banner">' +
                '<div class="oos-banner-icon">!</div>' +
                '<div class="oos-banner-content">' +
                '<p class="oos-banner-title">There\'s a problem with your order</p>' +
                '<p class="oos-banner-text">' + _.escape(message) + '</p>';

            if (showRemoveLink) {
                bannerHtml += '<a href="#" class="oos-banner-remove-link" data-action="remove-oos-items">Remove Out of Stock Items</a>';
            }

            bannerHtml += '</div></div>';

            container.html(bannerHtml);
        },

        clearBanner: function clearBanner() {
            jQuery('.oos-banner').remove();
            jQuery('[data-type="cart-detail-oos-error-placeholder"]').hide();
        },

        markOOSLines: function markOOSLines(oosLines) {
            _.each(oosLines, function(lineInfo) {
                var itemId = lineInfo.lineModel.get('item').get('internalid');
                var lineId = lineInfo.lineId;

                var byItemId = jQuery('[data-item-id="' + itemId + '"]');
                byItemId.addClass('cart-line-out-of-stock');

                var byLineId = jQuery('#' + lineId);
                if (byLineId.length) {
                    byLineId.addClass('cart-line-out-of-stock');
                }
            });
        },

        clearOOSMarks: function clearOOSMarks() {
            jQuery('.cart-line-out-of-stock').removeClass('cart-line-out-of-stock');
            jQuery('.cart-line-oos-label').remove();
            jQuery('.oos-count-label').remove();
        },

        addOOSLabels: function addOOSLabels(oosLines) {
            _.each(oosLines, function(lineInfo) {
                var itemId = lineInfo.lineModel.get('item').get('internalid');
                var lineId = lineInfo.lineId;

                var lineEl = jQuery('#' + lineId);
                if (!lineEl.length) {
                    lineEl = jQuery('[data-item-id="' + itemId + '"]');
                }

                    lineEl.each(function() {
                    if (!jQuery(this).find('.cart-line-oos-label').length) {
                        var nameEl = jQuery(this).find('.cart-lines-name, .cart-lines-table-middle');
                        nameEl.first().append('<span class="cart-line-oos-label">Out of Stock</span>');
                    }
                });
            });
        }
    };

    return {
        OOSUtils: OOSUtils,

        mountToApp: function mountToApp(container) {
            var isCheckout = SC.ENVIRONMENT.SCTouchpoint === 'checkout';

            if (isCheckout) {
                require(['AA.OutOfStock.Checkout'], function(CheckoutOOS) {
                    CheckoutOOS.init(container, OOSUtils);
                });
            } else {
                require(['AA.OutOfStock.Shopping'], function(ShoppingOOS) {
                    ShoppingOOS.init(container, OOSUtils);
                });
            }
        }
    };
});
